export default "__VITE_ASSET__CI0Sz8yD__"